import React, { useEffect } from "react";
import styles from "./ResaleShippingSelector.module.scss";
import classnames from "classnames";

export default function ResaleShippingSelector(props) {
    const { appProps, selectedAlternative, isTurnrExchangeSelected, setIsTurnrExchangeSelected } = props;
    const { getLocaleText } = appProps;

    const turnrAlternativeAvailable = selectedAlternative?.inventoryTurnr > 0;
    const storeShippingDisabled = selectedAlternative?.inventoryMerchant === 0;

    useEffect(() => {
        if (storeShippingDisabled && turnrAlternativeAvailable) {
            setIsTurnrExchangeSelected(true);
        }
        if (!turnrAlternativeAvailable) {
            setIsTurnrExchangeSelected(false);
        }
    }, [selectedAlternative]);

    return turnrAlternativeAvailable ? (
        <div className={styles["free-shipping-container"]}>
            <p className={styles["free-shipping-intro"]}>{getLocaleText("return-items-exchange-free-shipping-intro")}</p>
            <div className={styles["free-shipping-buttons-container"]}>
                <div className={classnames(styles["free-shipping-floating-bg"], !isTurnrExchangeSelected && styles["free-shipping-floating-bg-right"])} />
                <div
                    data-test-id={"free-shipping"}
                    onClick={() => setIsTurnrExchangeSelected(true)}
                    className={classnames(styles["free-shipping-button-text"], isTurnrExchangeSelected && styles["free-shipping-button-selected"])}
                >
                    {getLocaleText("return-items-exchange-free-shipping")}
                    <span className={styles["free-shipping-button-text-small"]}>{getLocaleText("return-items-exchange-free-shipping-returned-product")}</span>
                </div>
                <div
                    onClick={() => !storeShippingDisabled && setIsTurnrExchangeSelected(false)}
                    className={classnames(
                        styles["free-shipping-button-text"],
                        !isTurnrExchangeSelected && styles["free-shipping-button-selected"],
                        storeShippingDisabled && styles["free-shipping-store-disabled"],
                    )}
                >
                    {getLocaleText("return-items-exchange-shipping-cost")}
                    <span className={styles["free-shipping-button-text-small"]}>{getLocaleText("return-items-exchange-store-product")}</span>
                </div>
            </div>
            {/*{isTurnrExchangeSelected && (*/}
            {/*    <div className={styles["free-shipping-outro"]}>*/}
            {/*        <TurnrInfoAlert>{getLocaleText("return-items-exchange-free-shipping-outro")}</TurnrInfoAlert>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    ) : null;
}
